import { renderIcon } from '../../SvgIcon.esm.js';

/******************************************************
 * This file was created by scripts/generate.js as part
 * of the build process. Do not edit this file directly.
 ******************************************************/
var iconType = {
  viewBox: "0 0 24 24",
  paths: [{
    d: "M12.03 16.54c-.35-2.63 1.87-4.84 4.5-4.5 1.66.21 3.04 1.52 3.38 3.16.22 1.05-.01 2.02-.48 2.82l1.85 1.87c.39.39.39 1.02 0 1.41l-.094.083a.9959.9959 0 01-1.316-.083l-1.86-1.86c-.8.47-1.77.7-2.82.48-1.64-.34-2.94-1.72-3.16-3.38zm-1.8581-2.5344l.1781.0044c-.04.1-1.28 3.23 1.19 5.99H3c-.55 0-1-.45-1-1v-1c0-2.73 5.62-4.09 8.35-3.99zM16 14c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM10 4c2.2091 0 4 1.7909 4 4 0 2.2091-1.7909 4-4 4-2.2091 0-4-1.7909-4-4 0-2.2091 1.7909-4 4-4z",
    fillRule: "evenodd"
  }],
  circles: []
};
var PersonSearchIcon = function PersonSearchIcon(props) {
  return renderIcon(props, iconType);
};
export { PersonSearchIcon };